import APIExtensions from "../yoello-lib/modules/API2/APIDefs";
import { useAPIV2 } from "../yoello-lib/modules/API2/useAPIv2";
import ILocationAPIObject from "../interfaces/ILocationAPI";
import IVenue from "../interfaces/IVenue";
import { createNewVenue } from "../services/VenueController";
import { useState } from "react";
import { useSelector } from "react-redux";
import { IReduxAppState } from "../reducers";
import { useSentry } from "./useSentry";
import IVenueSettings from "../interfaces/IVenueSettings";
import { useTranslation } from "react-i18next";


export interface ICreateVenue {
    venue_location?: { value: string },
    venue_data: Partial<IVenue>;
    venue_setting_data: Partial<IVenueSettings>;
}

export function useCreateNewVenue() {
    const { t } = useTranslation()
    const { callAPI: callLocations } = useAPIV2<ILocationAPIObject>(APIExtensions.locations, { onMountDisabled: true, disableDispatcher: true });
    const { callAPI: callVenues } = useAPIV2<IVenue>(APIExtensions.venues, { onMountDisabled: true, successCall: t("snackbar.VenueCreateSuccess") });
    const { captureException } = useSentry();

    const selecetedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const venue = useSelector((state: IReduxAppState) => state.venue[selecetedVenueId]?.venueData);

    const [isLoading, setIsLoading] = useState(false);

    async function createVenue(data: ICreateVenue, copySelectedVenue?: boolean, useVenueProcessingFeePlansID?: boolean) {
        setIsLoading(true);
        const venueObject: Partial<IVenue> = data.venue_data!;
        if (copySelectedVenue && venue) {
            if (venue.payment_processor) {
                venueObject.payment_processor = venue.payment_processor;
            }
            if (venue.reseller) {
                venueObject.reseller = venue.reseller;
            }
            if (venue.onboarding_source) {
                venueObject.onboarding_source = venue.onboarding_source;
            }
            if (venue.specialist_name) {
                venueObject.specialist_name = venue.specialist_name;
            }
            if (venue.specialist_email) {
                venueObject.specialist_email = venue.specialist_email;
            }
            if (venue.processing_fees_plans_id && useVenueProcessingFeePlansID) {
                venueObject.processing_fees_plans_id = venue.processing_fees_plans_id;
            }
        }
        try {
            const results = await createNewVenue(callLocations, callVenues, { ...data, venue_data: venueObject });
            return results;
        } catch (error: any) {
            console.log(error,"Venue Creation Error",venueObject);
            captureException(error as any, 'createNewVenueHook', venueObject);
            throw error;
        } finally {
            setIsLoading(false);
        }
    }

    return {
        isLoading,
        createVenue
    }
}